<template>
    <div>
        <section class="container-fluid mt-2">
            <div class="row">
                <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                    <nav class="navbar navbar-breadcrumb navbar-expand-md bg-breadcrumb breadcrumb-borde">
                        <div class="mr-auto">
                            <nav aria-label="breadcrumb">
                                <ol class="breadcrumb clearfix pt-3">
                                    <!-- <li class="breadcrumb-item active">
                                        <a @click="Regresar()">Volver</a>
                                    </li> -->
                                    <li class="breadcrumb-item active">Project Management</li>
                                </ol>
                            </nav>
                        </div>
                    </nav>
                </div>
            </div>

            <div class="row">
                <div class="col-md-12 col-lg-12 col-xl-12 mt-2">
                    <Clist :isCrm="true" :pShowBtnAdd="ShowBtns" :ShowHead="false" @FiltrarC="Lista" :Filtro="Filtro" :regresar="true"  :Nombre="NameList"  :isModal="EsModal" :pConfigLoad="ConfigLoad" :isContactos="true" :ShowFilas="false">
                        <template slot="Botonnuevo">
                            <div class="col-md-12 col-lg-2 mt-2 text-right p-0">
                                <!-- <button v-if="disableHouseAccount" type="button" data-toggle="modal" data-target="#ModalNewUser"  data-backdrop="static" data-keyboard="false" class="btn btn-01 mr-1" @click="houseAccount()">House Account</button> -->
                                <button type="button" data-toggle="modal" :data-target="'#'+NombreSeccion"  data-backdrop="static" data-keyboard="false" class="btn btn-pink mr-3" @click="Nuevo()"><i class="far fa-plus-circle"></i> Nuevo</button>   
                            </div>
                        </template>
                        <template slot="Filtros">

                        </template>
                        <template slot="cards">
                            <div class="row row-cols-md-4 row-cols-lg-4 row-cols-xl-4 mt-3">
                                <div v-for="(lista,key) in ListaProyectos" :key="key" class="col-md-4 col-lg-4 col-xl-4 card-group">
                                    <div @click="IrADetalle(lista.IdProyecto,lista.CantidadProyectosSecundarios,lista.IdContrato,lista.Nombre,lista.IdContratoMaster)" class="card mb-3 tarjetacliente" style="border:2px solid #0F3F87;cursor:pointer;">
                                        <div class="card-body pt-2">
											<div :class="EvalEstatusProyecto(lista.Estatus)">
												<span class="bold w-100 m-auto d-flex justify-content-center">{{EvalCadenaEstatusProyecto(lista.Estatus)}}</span>
											</div>
											<div class="row h-100">
												<div class="col-lg-6">
													<img height="200px" v-if="lista.Imagen!=null && lista.Imagen!=''" class="w-100" :src="RutaImagenProyecto+lista.Imagen" alt=""/>
                                        			<img height="200px" v-else-if="lista.Imagen=='' && lista.LogoSucursal!=''" class="w-100" :src="ComprobarImagen(RutaImagenClienteSucursal+lista.IdClienteS+'/'+lista.LogoSucursal) ? RutaImagenClienteSucursal+lista.IdClienteS+'/'+lista.LogoSucursal : RutaImagenCliente+lista.LogoCliente" alt=""/>
                                        			<img height="200px" v-else-if="lista.Imagen=='' && lista.IdCliente!=0 && (lista.LogoCliente!='' && lista.LogoCliente!=null)" class="w-100" :src="RutaImagenCliente+lista.LogoCliente" alt=""/>
                                        			<div height="200px" v-else class="w-100" src="" alt="" style="background-color:#b4b4b4;padding:75px;height:50%"></div>
													<div class="row mt-1">
                                            		    <div class="col-lg-12">
                                            		        <h5 class="m-0 mt-2" v-b-tooltip.hover.top :title="lista.Nombre.toUpperCase()">
                                            		            {{$limitCharacters(lista.Nombre.toUpperCase(),22) }}
                                            		        </h5>
                                            		        <div class="row mt-2">
																<div class="col-lg-4 pr-0">
																	<span>Cliente:</span>
																</div>
																<div class="col-lg-8 pl-0">
																	<span v-b-tooltip.hover.top :title="lista.Cliente" class="bold">{{$limitCharacters(lista.Cliente,20)}}</span>
																</div>
															</div>
															<div class="row mt-2">
																<div class="col-lg-4 pr-0">
																	<span>Propiedad:</span>
																</div>
																<div class="col-lg-8 pl-0">
																	<span v-b-tooltip.hover.top :title="lista.Propiedad" class="bold">{{$limitCharacters(lista.Propiedad,20)}}</span>
																</div>
															</div>
															<div class="row mt-2">
																<div class="col-lg-4 pr-0">
																	<span>N° Proyecto:</span>
																</div>
																<div class="col-lg-8 pl-0">
																	<span v-b-tooltip.hover.top :title="lista.Contrato" class="bold">{{$limitCharacters(lista.Contrato,20)}}</span>
																</div>
															</div>
															<div class="row mt-2">
																<div class="col-lg-4 pr-0">
																	<span>P.M.:</span>
																</div>
																<div class="col-lg-8 pl-0">
																	<span v-b-tooltip.hover.top :title="lista.ProjectManager" class="bold">{{$limitCharacters(lista.ProjectManager,20)}}</span>
																</div>
															</div>
															<div class="row mt-2">
																<div class="col-lg-4 pr-0">
																	<span>Contratos:</span>
																</div>
																<div class="col-lg-8 pl-0">
																	<span class="bold">{{lista.CantidadProyectosSecundarios}}</span>
																</div>
															</div>
                                            		    </div>
                                            		</div>
												</div>
												<div class="col-lg-6 my-auto mt-2">
													<div class="row">
														<div class="col-lg-6 text-center">
															<span class="bold">Facturación vs Gasto Op.</span>
														</div>
														<div class="col-lg-6">
															<div :class="'cuadro-finanza-cardproyecto '+lista.FacturaVsGasto">
																<!-- <h2 class="text-center bold mt-1">{{lista.UtilidadEstimada}} %</h2> -->
															</div>
														</div>
													</div>
													<div class="row mt-4">
														<div class="col-lg-6 text-center">
															<span class="bold">Progreso Plan vs Progreso Actual</span>
														</div>
														<div class="col-lg-6">
															<div :class="'cuadro-finanza-cardproyecto '+lista.ProgresoPlanVsActual">
																<!-- <h2 class="text-center bold mt-1">{{lista.UtilidadEstimada}} %</h2> -->
															</div>
														</div>
													</div>
												</div>
												<!-- <div class="col-lg-6 mt-2">
													<span class="bold">Progreso Tiempo</span>
													<br>
													<div class="row">
														<div class="col-lg-10">
															<div class="barra-progreso">
																<div class="barra-progreso-relleno" style="background-color:#141199" :id="'progresotiempo'+key"></div>
															</div>
														</div>
														<div class="col-lg-2 mt-1 p-0">
															<h3 class="bold">{{lista.ProgresoTiempo}} %</h3>
														</div>
													</div>

													<span class="bold">Progreso</span>
													<br>
													<div class="row">
														<div class="col-lg-10">
															<div class="barra-progreso">
																<div class="barra-progreso-relleno" style="background-color:#141199" :id="'progreso'+key"></div>
															</div>
														</div>
														<div class="col-lg-2 mt-1 p-0">
															<h3 class="bold">{{lista.ProgresoProyecto}} %</h3>
														</div>
													</div>
													
													<span class="bold">Facturación Total Obra</span>
													<br>
													<div class="row">
														<div class="col-lg-10">
															<div class="barra-progreso">
																<div class="barra-progreso-relleno" style="background-color:#038ED9" :id="'facturado'+key"></div>
															</div>
														</div>
														<div class="col-lg-2 mt-1 p-0">
															<h3 class="bold">{{lista.FacturadoPorcen}} %</h3>
														</div>
													</div>

													<span class="bold">Cobrado Total Obra</span>
													<br>
													<div class="row">
														<div class="col-lg-10">
															<div class="barra-progreso">
																<div class="barra-progreso-relleno" style="background-color:#038ED9" :id="'cobrado'+key"></div>
															</div>
														</div>
														<div class="col-lg-2 mt-1 p-0">
															<h3 class="bold">{{lista.CobradoPorcen}} %</h3>
														</div>
													</div>

													<div class="row mt-2 d-flex justify-content-center align-items-center">
														<div class="col-lg-6">
															<span class="bold">Financiamiento</span>
														</div>
														<div class="col-lg-6">
															<div :class="'cuadro-finanza-cardproyecto '+EvalFinanciamiento(lista)">
																<h2 class="text-center bold mt-1">{{lista.Financiamiento}} %</h2>
															</div>
														</div>
													</div>
													<div class="row mt-3 d-flex justify-content-center align-items-center">
														<div class="col-lg-6">
															<span class="bold">Utilidad Estimada</span>
														</div>
														<div class="col-lg-6">
															<div :class="'cuadro-finanza-cardproyecto color-verde-proyecto'">
																<h2 class="text-center bold mt-1">{{lista.UtilidadEstimada}} %</h2>
															</div>
														</div>
													</div>
													<div class="row mt-3 d-flex justify-content-center align-items-center">
														<div class="col-lg-6">
															<span class="bold">Utilidad Actual</span>
														</div>
														<div class="col-lg-6">
															<div :class="'cuadro-finanza-cardproyecto '+EvalUtilidadActual(lista.UtilidadActual)">
																<h2 class="text-center bold mt-1"> {{lista.UtilidadActual}}%</h2>
															</div>
														</div>
													</div>
												</div> -->
											</div>
                                        </div>
                                    </div>
                                    <div class="editar_contactos dropright">
                                        <button type="button" style="background:rgba(0,0,0,0); border:none;"
                                            title="Menu"
                                            id="dropdownMenuButton"
                                            data-toggle="dropdown"
                                            aria-haspopup="true"
                                            aria-expanded="false"
                                            >
                                                <i class="fa fa-ellipsis-v"></i>
                                        </button>
                                        <div class="dropdown-menu dropdown-menu-user" aria-labelledby="dropdownMenuButton">
                                            <div class="dropdown-menu-header">
                                                <h4 style="opacity:1" class="widget-nombre mt-1 text-center">Seleccione una opción</h4>
                                            </div>
                                            <!-- <a
                                                @click="AgregarTrabajador(lista.IdProyecto)"
                                                data-toggle="modal"
                                                :data-target="'#AgregarTrabajador'"
                                                data-backdrop="static"
                                                class="dropdown-item"
                                                >
                                                <i class="fa fa-user fa-fw-m"></i> Asignar Personal
                                            </a> -->

                                            <a
                                                @click="Editar(lista.IdProyecto)"
                                                data-toggle="modal"
                                                :data-target="'#'+NombreSeccion"
                                                data-backdrop="static"
                                                class="dropdown-item"
                                                >
                                                <i class="fa fa-pencil fa-fw-m"></i> Editar
                                            </a>
            
                                            <a
                                                @click="Eliminar(lista.IdProyecto)"
                                                data-backdrop="static"
                                                class="dropdown-item"
                                                >
                                                <i class="fa fa-trash fa-fw-m"></i> Eliminar
                                            </a>

											<a
                                                @click="EditarUbicacion(lista.IdProyecto)"
                                                data-toggle="modal"
                                                :data-target="'#'+NombreSeccionUbicacion"
                                                data-backdrop="static"
                                                class="dropdown-item"
                                                >
                                                <i class="fa fa-map-marker-alt fa-fw-m"></i> Ubicación
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </Clist>
                    <Modal :NameModal="NombreSeccion" :size="size" :Nombre="NameList" :poBtnSave="oBtnSave" :pEmitSeccion="EmitSeccion">
                        <template slot="Form">
                            <Form :poBtnSave="oBtnSave" :pRutaImagenCliente="RutaImagenCliente" :pRutaImagenPropiedad="RutaImagenClienteSucursal">
                            </Form>
                        </template>
                    </Modal> 
                    <Modal :NameModal="'AgregarTrabajador'" :size="'modal-lg'" :Nombre="'Asignar Personal'" :poBtnSave="oBtnSaveTrabajador" :pEmitSeccion="EmitSeccionTrabajador">
                        <template slot="Form">
                            <Trabajador :poBtnSave="oBtnSaveTrabajador" >
                            </Trabajador>
                        </template>
                    </Modal> 
					<Modal :NameModal="'Ubicacion'" :size="'modal-lg'" :Nombre="'Ubicación'" :poBtnSave="oBtnSaveUbicacion" :pEmitSeccion="EmitSeccionUbicacion">
                        <template slot="Form">
                            <Ubicacion :poBtnSave="oBtnSaveUbicacion" >
                            </Ubicacion>
                        </template>
                    </Modal> 
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import Modal from '@/components/Cmodal.vue';
import Clist from '@/components/Clist.vue';
import Cbtnaccion from '@/components/Cbtnaccion.vue';
import Form from '@/views/modulos/proyecto/Form.vue';
import Trabajador from '@/views/modulos/proyecto/AgregarTrabajador.vue';
import AgregarTrabajador from './AgregarTrabajador.vue';
import Ubicacion from './Ubicacion.vue';
// import Menu from "../indexMenu.vue";

export default {
    name :'list',
    props:[],
    components :{
        Modal,
        Clist,
        Cbtnaccion,
        Form,
        Trabajador,
		Ubicacion
        // Menu,
    },
    data() {
        return {
            NombreSeccion: 'Proyectos',
			NombreSeccionUbicacion:'Ubicacion',
            FormName:'ProyectosForm',
            EsModal:true,
            size :"modal-size-50-vw",
            NameList:"Proyecto",
            EmitSeccion:"Proyecto",
            EmitSeccionTrabajador:"AgregarTrabajador",
			EmitSeccionUbicacion:"Ubicacion",
            urlApi:"proyectos/list",
            ListaProyectos:[],
            ShowBtns:true,
            TipoList:'',
            Filtro:{
                Nombre:'',
                Placeholder:'Nombre..',
                TotalItem:0,
                Pagina:1,
                Entrada:30
            },
            oBtnSave:{
                isModal:true,
                disableBtn:false,
                toast:0,
                nombreModal:"Proyectos",
                EmitSeccion:'Proyecto'
            },
            oBtnSaveTrabajador:{
                isModal:true,
                disableBtn:false,
                toast:0,
                nombreModal:"AgregarTrabajador",
                EmitSeccion:'AgregarTrabajador'
            },
			oBtnSaveUbicacion:{
                isModal:true,
                disableBtn:false,
                toast:0,
                nombreModal:"Ubicacion",
                EmitSeccion:'Ubicacion'
            },
            ConfigLoad:{
				ShowLoader:true,
				ClassLoad:true,
			},
            RutaImagenProyecto:"",
            RutaImagenCliente:"",
            RutaImagenClienteSucursal:"",
        }
    },
    methods: {
        Nuevo()
        {
            if (this.oBtnSave.isModal==true)
            { 
                this.bus.$emit('NewModal_'+this.EmitSeccion,true);
            }
            else{
                this.bus.$emit('NewModal_'+this.EmitSeccion);
            }
        },
        Eliminar(Id)
        {
            this.$swal({
                title: 'Esta seguro que desea eliminar este dato?',
                text: 'No se podra revertir esta acción',
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Si',
                cancelButtonText: 'No, mantener',
                showCloseButton: true,
                showLoaderOnConfirm: true
            }).then((result) => {
                if(result.value) {
                    this.$http.delete(
                        'proyectos/' + Id
                    ).then( (res) => {
                        this.$toast.success('Información eliminada');
                        this.Lista();
                    });
                } 
            });
        },
        Editar(Id){
            this.bus.$emit('NewModal_'+this.EmitSeccion,false,Id);
        },
		EditarUbicacion(Id){
			this.bus.$emit('NewModal_'+this.EmitSeccionUbicacion,false,Id);
		},
        AgregarTrabajador(Id){
            this.bus.$emit('NewModal_'+this.EmitSeccionTrabajador,false,Id)
        },
        async Lista(){
            this.ConfigLoad.ShowLoader = true;
            await this.$http.get(
                'proyectos/get',
                {
                    params:{
                        Nombre:this.Filtro.Nombre,
                        Entrada:this.Filtro.Entrada,
                        pag:this.Filtro.Pagina, 
                        RegEstatus:'A',
                    }
                }
            ).then((res)=>{
                this.ListaProyectos=res.data.data.proyectos;
                this.Filtro.Entrada=res.data.pagination.PageSize;
                this.Filtro.TotalItem=res.data.pagination.TotalItems; 
                this.RutaImagenProyecto=res.data.data.rutaImagenProyecto;
                this.RutaImagenCliente=res.data.data.rutaImagenCliente;
                this.RutaImagenClienteSucursal=res.data.data.rutaImagenClienteSucursal;
            }).finally(()=>{
				// let Contador=0;
				// this.ListaProyectos.forEach((value) => {
				// 	let ElementoProgresoTiempo=document.getElementById('progresotiempo'+Contador);
				// 	let ElementoProgreso=document.getElementById('progreso'+Contador);
				// 	let ElementoFacturado=document.getElementById('facturado'+Contador);
				// 	let ElementoCobrado=document.getElementById('cobrado'+Contador);
				// 	ElementoProgresoTiempo.style.width=Number(value.ProgresoTiempo)>=100 ? 100+'%' : value.ProgresoTiempo+'%';
				// 	ElementoProgreso.style.width=value.ProgresoProyecto+'%';
				// 	ElementoFacturado.style.width=value.FacturadoPorcen+'%';
				// 	ElementoCobrado.style.width=value.CobradoPorcen+'%';
				// 	Contador++;
				// })
				this.ConfigLoad.ShowLoader = false;
			});
        },
        Regresar(){
            this.$router.push({name:'proyectos'});
        },
        ComprobarImagen(ImageUrl){
            var img = new Image();
            img.src = ImageUrl;
            return img.height!=0;
        },
		IrADetalle(IdProyecto,CantidadProyectosSecundarios,IdContratoMaster,Nombre="",IdContratoPadre=0){
			if (CantidadProyectosSecundarios>1) {
				this.$router.push({name:'proyectosrelacionados',params:{pIdContratoMaster:IdContratoMaster,pNombre:Nombre}});	
			}
			else{
				// console.log(IdContratoMaster);
				this.$router.push({name:'proyectodesglose',params:{IdProyecto:IdProyecto,IdContratoMaster:IdContratoPadre}});
			}
		},
		EvalEstatusFinanciero(item){
			let Cadena='';
			let Negativo=-item.GananciaEstimada;
			if (item.EstatusFinanciero<=Negativo) {
				Cadena='color-rojo-proyecto';
			}
			else if (item.EstatusFinanciero>Negativo && item.EstatusFinanciero<=0) {
				Cadena='color-naranja-proyecto';
			}
			else if (item.EstatusFinanciero>0 && item.EstatusFinanciero<item.GananciaEstimada) {
				Cadena='color-amarillo-proyecto';
			}
			else{
				Cadena='color-verde-proyecto';
			}
			return Cadena;
		},
		EvalFinanciamiento(item){
			let Cadena='';
			if (item.Financiamiento<=5) {
				Cadena='color-verde-proyecto';
			}
			else if (item.Financiamiento>5 && item.Financiamiento<=10) {
				Cadena='color-amarillo-proyecto';
			}
			else if (item.Financiamiento>10 && item.Financiamiento<=20) {
				Cadena='color-naranja-proyecto';
			}
			else{
				Cadena='color-rojo-proyecto';
			}
			return Cadena;
		},
		EvalUtilidadEstimada(item){
			let Cadena='';
			if (item.EvalUtilidadEstimada>=3) {
				Cadena='color-verde-proyecto';
			}
			else if(item.EvalUtilidadEstimada<3 && item.EvalUtilidadEstimada>1){
				Cadena='color-amarillo-proyecto';
			}
			else if(item.EvalUtilidadEstimada<=1 && item.EvalUtilidadEstimada>=0){
				Cadena='color-naranja-proyecto';
			}
			else{
				Cadena='color-rojo-proyecto';
			}
			return Cadena;
		},
		EvalUtilidadActual(UtilidadActual){
			let Cadena='';
			if (UtilidadActual<=0) {
				Cadena='color-rojo-proyecto';
			}
			else{
				Cadena='color-verde-proyecto';
			}
			return Cadena;
		},
		formateoMillon(numero){
            let fixed = 0;
			let e=0;
			if (numero === null) {
				return null;
			} // terminate early
			if (numero === 0) {
				return "0";
			} // terminate early
			fixed = !fixed || fixed < 0 ? 0 : fixed; // number of decimal places to show
			var b = numero.toPrecision(2).split("e"), // get power
				k = b.length === 1 ? 0 : Math.floor(Math.min(b[1].slice(1), 14) / 6), // floor at decimals, ceiling at trillions
				c =
					k < 1
						? numero.toFixed(0 + fixed)
						: (numero / Math.pow(10, k * 6)).toFixed(1 + fixed), // divide by power
				d = c < 0 ? c : Math.abs(c); // enforce -0 is 0
				if (k==0) {
					// e=new Intl.NumberFormat('en-US',{style:'currency',currency:'USD',roundingPriority:'morePrecision'}).format(d);
					e=d.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
				}
				else{
					e = d + ["", " M", " B", " T"][k]; // append power
				}
			return e;
        },
		EvalEstatusProyecto(Estatus){
			let Cadena='estatus-proyecto';
			switch (Estatus) {
				case '1':
					Cadena+=' estatus-proyecto-verde';
					break;
				case '2':
					Cadena+=' estatus-proyecto-rojo';
					break;
				case '3':
					Cadena+=' estatus-proyecto-amarillo';
					break;
				case '4':
					Cadena+=' estatus-proyecto-violeta';
					break;
				default:
					break;
			}
			return Cadena;
		},
		EvalCadenaEstatusProyecto(Estatus){
			let Cadena='';
			switch (Estatus) {
				case '1':
					Cadena='Activo';
					break;
				case '2':
					Cadena='Inactivo';
					break;
				case '3':
					Cadena='Pausado';
					break;
				case '4':
					Cadena='Cerrado';
					break;
				default:
					break;
			}
			return Cadena;
		}
    },
    created() {
		sessionStorage.removeItem("IdContratoMaster");
		sessionStorage.removeItem("Nombre");
        this.bus.$off('Delete');
        this.bus.$off('List');
        this.Lista();
        this.bus.$on('Delete',(Id)=> 
        {
            this.Eliminar(Id);
        });
        this.bus.$on('List',()=> 
        {
            this.Lista();
        });
    },
}
</script>

<style>

</style>
